<template>
    <div class="base_box_hdr">
        <div class="base_box_cnt">
            <div class="row">
                <div class="col-sm-8">
                    <h1 class="title">{{ title }}</h1>
                </div>
                <div class="col-sm-4" v-show="0">
                    <div class="base_input_bx">
                        <input type="text" class="form-control base_input" :placeholder='i18n("Search")'>
                        <i class="mdi mdi-magnify"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HomeHeader",
        props: {
            title: String,
        }
    }
</script>

<style scoped>
    .title {
        margin: 7px;
    }
</style>
